// extracted by mini-css-extract-plugin
export default {"addContact":"AddContactBtn_addContact__aeooJ","icon":"AddContactBtn_icon__rbq4t","span":"AddContactBtn_span__LtwbU"};